








import Vue from 'vue';

// Components
import Loading from './base/Loading.vue';

export default Vue.extend({
    name: 'VFairListItemSkeleton',
    components: {
        Loading,
    },
});
